import { auth } from '@/lib';
import { useRunOnce } from '@nosinovacao/nosid-mfe-common';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/login-complete')({
  component: RouteComponent,
  staticData: {
    anonymous: true,
  },
});

function RouteComponent() {
  const navigate = Route.useNavigate();
  async function onLogin() {
    const redirectPath = await auth.processLoginRedirect();
    const { pathname, searchParams } = new URL(redirectPath, globalThis.location.origin);
    navigate({
      to: pathname,
      search: Object.fromEntries(searchParams.entries()),
    });
  }
  useRunOnce(() => {
    onLogin();
  });
  return <></>;
}
